import axios from "axios";
import store from '@/store'

axios.defaults.headers.get['Pragma'] = 'no-cache';
axios.defaults.headers.get['Cache-Control'] = 'no-cache, no-store';
const service = axios.create({
    baseURL: '/',
    timeout: 10000,
});


service.interceptors.request.use(
    config => {
        const token = store && store.state.userInfo.userinfo.accessToken ? store.state.userInfo.userinfo.accessToken : undefined
        if(token){
            config.headers.Authorization='bearer ' + token
        }
        return config;
    },
    error => {
        console.log(error); // for debug
        return Promise.reject(error);
    }
);


service.interceptors.response.use(
    response => {
        const {data} = response;
        if(data.code==='expire'){
            window.location.reload()
        }
        if (response instanceof Blob) {
            return response;
        }
        return data;
    },
    error => {
        let res = error.response;
        if(res.status===401){
            window.location.reload()
        }
        return Promise.reject(res);
    }
);

export default service;